const wtConsole = require('./wtConsole').default
module.exports = wtConsole
module.exports.default = wtConsole

//# sourceMappingURL=index.js.map
